// Navigation - main/top
export const navigationHomeSelector = ({ navigationData }) =>
  navigationData.home;
export const navigationMessagesSelector = ({ navigationData }) =>
  navigationData.messages;
export const navigationContactsSelector = ({ navigationData }) =>
  navigationData.contacts;
export const navigationJobsSelector = ({ navigationData }) =>
  navigationData.jobs;
export const navigationMenuSelector = ({ navigationData }) =>
  navigationData.menu;
export const navigationHelpPersonalSelector = ({ navigationData }) =>
  navigationData.helpPersonal;

// Navigation -- armstrong
export const navigationHomeArmstrongSelector = ({ navigationData }) =>
  navigationData.homeArmstrong;
export const navigationDiscoverArmstrongSelector = ({ navigationData }) =>
  navigationData.discover;
export const navigationMeHubV2ArmstrongSelector = ({ navigationData }) =>
  navigationData.meV2;
export const navigationJobsArmstrongSelector = ({ navigationData }) =>
  navigationData.jobsArmstrong;
export const navigationPremiumUpsellArmstrongSelector = ({ navigationData }) =>
  navigationData.premiumUpsellArmstrong;
export const navigationProJobsUpsellArmstrongSelector = ({ navigationData }) =>
  navigationData.proJobsUpsellArmstrong;
export const navigationBusinessArmstrongSelector = ({ navigationData }) =>
  navigationData.businessArmstrong;
export const navigationPremiumArmstrongSelector = ({ navigationData }) =>
  navigationData.premiumArmstrong;
export const navigationProJobsArmstrongSelector = ({ navigationData }) =>
  navigationData.proJobsArmstrong;
export const navigationProBusinessArmstrongSelector = ({ navigationData }) =>
  navigationData.proBusinessArmstrong;
export const navigationEventsArmstrongSelector = ({ navigationData }) =>
  navigationData.eventsArmstrong;
export const navigationContentArmstrongSelector = ({ navigationData }) =>
  navigationData.contentArmstrong;
export const navigationGroupsArmstrongSelector = ({ navigationData }) =>
  navigationData.groupsArmstrong;
export const fabNavigationSelector = ({ navigationData }) => navigationData.fab;
export const navigationSettingsPersonalArmstrongSelector = ({
  navigationData,
}) => navigationData.settingsPersonalArmstrong;
export const navigationLogoutPersonalArmstrongSelector = ({ navigationData }) =>
  navigationData.logoutPersonalArmstrong;
export const feedbackInfoV2ArmstrongSelector = ({ navigationData }) =>
  navigationData.feedbackInfoV2Armstrong;
export const navigationMessengerTopBarSelector = ({ navigationData }) =>
  navigationData.messengerTopBar;

// Navigation - secondary/other
export const navigationContentSelector = ({ navigationData }) =>
  navigationData.content;
export const navigationEventsSelector = ({ navigationData }) =>
  navigationData.events;
export const navigationGroupsSelector = ({ navigationData }) =>
  navigationData.groups;
export const navigationCompaniesSelector = ({ navigationData }) =>
  navigationData.companies;
export const navigationServicesSelector = ({ navigationData }) =>
  navigationData.services;
export const navigationPremiumSelector = ({ navigationData }) =>
  navigationData.premium;
export const navigationPremiumUpsellSelector = ({ navigationData }) =>
  navigationData.premiumUpsell;
export const navigationProJobsSelector = ({ navigationData }) =>
  navigationData.proJobs;
export const navigationProBusinessSelector = ({ navigationData }) =>
  navigationData.proBusiness;
export const navigationSettingsPersonalSelector = ({ navigationData }) =>
  navigationData.settingsPersonal;
export const navigationLogoutPersonalSelector = ({ navigationData }) =>
  navigationData.logoutPersonal;
export const navigationHelpFooterSelector = ({ navigationData }) =>
  navigationData.helpFooter;
export const navigationImprintSelector = ({ navigationData }) =>
  navigationData.imprintFooter;
export const navigationTAndCSelector = ({ navigationData }) =>
  navigationData.tAndCFooter;
export const navigationPrivacyAtXingSelector = ({ navigationData }) =>
  navigationData.privacyAtXingFooter;
export const navigationPrivacyPolicySelector = ({ navigationData }) =>
  navigationData.privacyPolicyFooter;
export const navigationBusinessSelector = ({ navigationData }) =>
  navigationData.business;

// About Links
export const aboutFooterSelector = ({ navigationData }) =>
  navigationData.aboutFooter;
export const developersFooterSelector = ({ navigationData }) =>
  navigationData.developersFooter;

// UpSell Header Links
export const premiumUpsellHeaderSelector = ({ navigationData }) =>
  navigationData.premiumUpsellHeader;
export const proJobsUpsellHeaderSelector = ({ navigationData }) =>
  navigationData.proJobsUpsellHeader;

// Settings Dropdown Links
export const premiumUpsellPersonalSelector = ({ navigationData }) =>
  navigationData.premiumUpsellPersonal;
export const proJobsPersonalSelector = ({ navigationData }) =>
  navigationData.proJobsPersonal;
export const proJobsMemberPersonalSelector = ({ navigationData }) =>
  navigationData.proJobsMemberPersonal;
export const coachProfilePersonalSelector = ({ navigationData }) =>
  navigationData.coachProfilePersonal;
export const xtmPersonalSelector = ({ navigationData }) =>
  navigationData.xtmPersonal;
export const seatManagerAdminPersonalSelector = ({ navigationData }) =>
  navigationData.seatManagerAdminPersonal;
export const jobsPosterPersonalSelector = ({ navigationData }) =>
  navigationData.jobsPosterPersonal;
export const brandPagePersonalSelector = ({ navigationData }) =>
  navigationData.brandPagePersonal;
export const admasterUserPersonalSelector = ({ navigationData }) =>
  navigationData.admasterUserPersonal;
export const brandManagerEditorSelector = ({ navigationData }) =>
  navigationData.brandManagerEditor;
export const invoicesPersonalSelector = ({ navigationData }) =>
  navigationData.invoicesPersonal;

// FOOTER
// Apps Links
export const iphoneIpadFooterSelector = ({ navigationData }) =>
  navigationData.iphoneIpadFooter;
export const androidFooterSelector = ({ navigationData }) =>
  navigationData.androidFooter;
export const windows10FooterSelector = ({ navigationData }) =>
  navigationData.windows10Footer;

// Company Links
export const newWorkFooterSelector = ({ navigationData }) =>
  navigationData.newWorkFooter;
export const careersFooterSelector = ({ navigationData }) =>
  navigationData.careersFooter;
export const investorRelationsFooterSelector = ({ navigationData }) =>
  navigationData.investorRelationsFooter;
export const pressFooterSelector = ({ navigationData }) =>
  navigationData.pressFooter;
export const newWorkExperienceFooterSelector = ({ navigationData }) =>
  navigationData.newWorkExperienceFooter;

// Legal Links
export const imprintFooterSelector = ({ navigationData }) =>
  navigationData.imprintFooter;
export const tAndCFooterSelector = ({ navigationData }) =>
  navigationData.tAndCFooter;
export const privacyAtXingFooterSelector = ({ navigationData }) =>
  navigationData.privacyAtXingFooter;
export const privacyPolicyFooterSelector = ({ navigationData }) =>
  navigationData.privacyPolicyFooter;

// Main Sections Links
export const peopleDirectoryFooterSelector = ({ navigationData }) =>
  navigationData.peopleDirectoryFooter;
export const jobsFooterSelector = ({ navigationData }) =>
  navigationData.jobsFooter;
export const eventsFooterSelector = ({ navigationData }) =>
  navigationData.eventsFooter;
export const newsFooterSelector = ({ navigationData }) =>
  navigationData.newsFooter;
export const groupsFooterSelector = ({ navigationData }) =>
  navigationData.groupsFooter;
export const companiesFooterSelector = ({ navigationData }) =>
  navigationData.companiesFooter;
export const coachesFooterSelector = ({ navigationData }) =>
  navigationData.coachesFooter;

// Memberships Links
export const premiumOfferSelector = ({ navigationData }) =>
  navigationData.premiumOfferFooter;
export const proJobsOfferSelector = ({ navigationData }) =>
  navigationData.proJobsOfferFooter;

// Reources Links
export const helpFooterSelector = ({ navigationData }) =>
  navigationData.helpFooter;
export const xingCommunityFooterSelector = ({ navigationData }) =>
  navigationData.xingCommunityFooter;
export const devBlogFooterSelector = ({ navigationData }) =>
  navigationData.devBlogFooter;
export const appsSelector = ({ navigationData }) => navigationData.appsFooter;

// Services Links
export const eRecruitingOfferSelector = ({ navigationData }) =>
  navigationData.eRecruitingOfferFooter;
export const halloFreelancerOfferSelector = ({ navigationData }) =>
  navigationData.halloFreelancerOfferFooter;
export const advertisementOfferSelector = ({ navigationData }) =>
  navigationData.advertisementOfferFooter;
export const marketingSolutionsOfferSelector = ({ navigationData }) =>
  navigationData.marketingSolutionsOfferFooter;
export const xingEventsOfferSelector = ({ navigationData }) =>
  navigationData.xingEventsOfferFooter;
export const curriculumVitaeEditorSelector = ({ navigationData }) =>
  navigationData.curriculumVitaeEditorFooter;
export const coverLetterEditorSelector = ({ navigationData }) =>
  navigationData.coverLetterEditorFooter;
export const jobApplicationTipsSelector = ({ navigationData }) =>
  navigationData.jobApplicationTipsFooter;
export const kununuOfferSelector = ({ navigationData }) =>
  navigationData.kununuOfferFooter;

// Others
export const mobileOfferSelector = ({ navigationData }) =>
  navigationData.mobileOffer;
export const loginWithXingSelector = ({ navigationData }) =>
  navigationData.loginWithXing;
export const shareButtonSelector = ({ navigationData }) =>
  navigationData.shareButton;
export const downloadsSelector = ({ navigationData }) =>
  navigationData.downloads;

export const notificationCenterWebSelector = ({ navigationData }) =>
  navigationData.notificationCenterWeb;
